import { Box, type SxProps, type Theme } from '@mui/material';

/**
 * Official party logo (docs/brand/party, synced by scripts/sync-brand.sh).
 * Colour version on light backgrounds, white version in dark mode — never recoloured.
 * `tagline` = "Partia Demokratike e Shqipërisë" (formal contexts);
 * default = "Partia Demokratike" (digital / small spaces), per the identity guidelines.
 */
export function BrandLogo({
  tagline = false,
  emblem = false,
  sx,
}: {
  tagline?: boolean;
  /** Only the round "D" emblem (collapsed sidebar). */
  emblem?: boolean;
  sx?: SxProps<Theme>;
}) {
  const alt = tagline ? 'Partia Demokratike e Shqipërisë' : 'Partia Demokratike';
  const [colour, white] = emblem
    ? ['emblem', 'emblem-white']
    : tagline
      ? ['COLOR_Partia_Demokratike_e_Shqiperise', 'WHITE_Partia_Demokratike_e_Shqiperise']
      : ['COLOR_Partia_Demokratike', 'WHITE_Partia_Demokratike'];
  return (
    <Box sx={[{ display: 'inline-flex' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Box
        component="img"
        src={`/brand/${colour}.svg`}
        alt={alt}
        sx={(th) => ({
          height: '100%',
          width: 'auto',
          ...th.applyStyles('dark', { display: 'none' }),
        })}
      />
      <Box
        component="img"
        src={`/brand/${white}.svg`}
        alt={alt}
        sx={(th) => ({
          height: '100%',
          width: 'auto',
          display: 'none',
          ...th.applyStyles('dark', { display: 'block' }),
        })}
      />
    </Box>
  );
}
